// import node module libraries
import { Fragment, useState, useEffect, useMemo } from 'react';
//import { useLocation } from 'react-router-dom';

// import sub components
import PricingPlans from './PricingPlans';
import ComparePlansTable from './ComparePlansTable';
import FAQs from './FAQs';
import Quotes from './Quotes';

import SEO from 'components/marketing/seo/Seo';

// import layouts
import NavbarHaeppyapp from 'layouts/marketing/navbars/NavbarHaeppyapp';
import FooterHaeppyapp from 'layouts/marketing/footers/FooterHaeppyapp';

const ComparePlan = () => {

	// State for subscriptions
	const [currentPlan, setCurrentPlan] = useState(() => {
		return JSON.parse(localStorage.getItem('_tenant_subscriptions')) || [];
	});

	return (
		<Fragment>
			<SEO
				title="Preise und Pläne vergleichen"
				description="Vergleiche unsere SaaS-Pakete für Multi-Channel E-Commerce: Flexible Preise, skalierbare Funktionen & einfache Integration. Jetzt den passenden Plan wählen."
				keywords="multi channel saas preise, e-commerce saas preise"
				canonical="https://haeppy.app/marketing/pages/compare-plan/"
			/>
			{/* Default Navbar */}
			<NavbarHaeppyapp
				transparent={true}
				center={false}
			/>

			{/* pricing plans  */}
			<PricingPlans currentPlan={currentPlan[0]?.plan} />

			{/* compare plan & additional features 
			<ComparePlansTable />*/}

			{/* FAQs section */}
			<FAQs />

			{/* Quotes */}
			<Quotes />
		</Fragment>
	);
};

export default ComparePlan;
